import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IdName, ToastService} from '@core/src/public-api';
import {LoginService} from '@shared/services/login.service';
import {AppConfigService} from '@shared/services/app-config.service';
import {configVariableValues} from '@shared/constants/config-variable-values.constants';

@Component({
  selector: 'si-health-insurance-selector',
  templateUrl: './health-insurance-selector.component.html',
  styleUrls: ['./health-insurance-selector.component.scss']
})
export class HealthInsuranceSelectorComponent implements OnInit {
  @Input() text: string;
  @Input() tooltipText: string;
  @Input() privateInsurance: boolean;
  @Input() collective: IdName;
  @Input() showButton = true;
  @Input() disabled: boolean;
  @Output() privateInsuranceChange = new EventEmitter<boolean>();
  @Output() collectiveChange = new EventEmitter<IdName>();
  allInsurances: boolean;
  multipleInsuranceAvailable: boolean;

  constructor(
    private loginService: LoginService,
    private toastService: ToastService,
    private appConfigService: AppConfigService
  ) { }

  ngOnInit(): void {
    this.allInsurances = !this.loginService.getIsPatient();
    this.getConfigurations();
  }

  async getConfigurations(): Promise<void> {
    await this.appConfigService.getConfigurations();
    this.multipleInsuranceAvailable = this.appConfigService.hasConfigurationEnabled(configVariableValues.MULTIPLE_INSURANCE_AVAILABLE);
    if (!this.multipleInsuranceAvailable && !this.privateInsurance) {
      this.privateInsurance = true;
      this.privateInsuranceChange.emit(this.privateInsurance);
    }
  }

  selectDefaultLoaded(defaultValue: any): void {
    this.collective = defaultValue;
    this.collectiveChange.emit(this.collective);
  }

  onChangeSelectorModel(): void {
    this.collectiveChange.emit(this.collective);
  }

  onChangeRadioButtonModel(): void {
    this.privateInsuranceChange.emit(this.privateInsurance);
  }

  onSucessAddInsurance(collective: IdName): void {
    this.collective = collective;
    this.privateInsurance = false;
    this.collectiveChange.emit(this.collective);
    this.privateInsuranceChange.emit(this.privateInsurance);
  }

  async onLoadedOptions(optionsLength: number): Promise<void> {
    if (!optionsLength && this.multipleInsuranceAvailable) {
      await this.toastService.warning('SI_NO_INSURANCE_WARNING');
    }
  }
}
